<template>
    <!-- logo -->
    <img src="/public/assets/logo_qnb.png" alt="Logo" class="w-auto" />
</template>
